import { render, staticRenderFns } from "./Decisao.vue?vue&type=template&id=24df6706&scoped=true"
import script from "./Decisao.vue?vue&type=script&lang=js"
export * from "./Decisao.vue?vue&type=script&lang=js"
import style0 from "./Decisao.vue?vue&type=style&index=0&id=24df6706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df6706",
  null
  
)

export default component.exports